import { Sparkles, ArrowRight, Share2, ShieldCheck, Gauge, Lightbulb } from "lucide-react";

export function ShareBanner({ analysis }) {
  const title = analysis?.video_metadata?.title;
  return (
    <div data-testid="share-banner" className="vt-dark-zone relative overflow-hidden rounded-2xl border border-purple-400/30 bg-gradient-to-r from-brand-bg via-[#140f3a] to-brand-bg text-white p-4 md:p-5 mb-6">
      <div className="pointer-events-none absolute -left-10 top-1/2 -translate-y-1/2 w-72 h-72 rounded-full bg-purple-600/30 blur-[90px]" />
      <div className="pointer-events-none absolute right-0 top-0 w-56 h-56 rounded-full bg-pink-600/20 blur-[90px]" />
      <div className="relative flex flex-col md:flex-row md:items-center gap-4">
        <span className="w-11 h-11 rounded-xl bg-purple-500/15 border border-purple-400/40 text-purple-300 flex items-center justify-center shrink-0 shadow-[0_0_18px_rgba(139,92,246,0.4)]">
          <Share2 className="w-5 h-5" />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-purple-300">Informe compartido · generado con IA por ViralTubeAI</p>
          <p className="font-bold text-white truncate">{title ? `Análisis de "${title}"` : "Análisis completo de un video de YouTube"}</p>
          <p className="text-xs text-brand-text2 mt-0.5">Puntuación viral, retención, SEO, hooks, insights y recomendaciones accionables.</p>
        </div>
        <a href="/" data-testid="share-banner-cta" className="vt-btn-primary vt-cta-glow text-sm rounded-full shrink-0">
          <Sparkles className="w-4 h-4" /> Analiza tu video gratis
        </a>
      </div>
    </div>
  );
}

export function ShareFooterCTA() {
  const points = [
    [Gauge, "Score viral de 0 a 100 con desglose por factor"],
    [Lightbulb, "Insights y recomendaciones priorizadas por impacto"],
    [ShieldCheck, "3 análisis gratis · sin tarjeta · con tu cuenta de Google"],
  ];
  return (
    <section data-testid="share-footer-cta" className="vt-dark-zone relative overflow-hidden rounded-3xl border border-purple-400/30 bg-gradient-to-b from-brand-bg via-[#140f3a] to-brand-bg text-white p-8 md:p-12 text-center mt-4">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[640px] h-[360px] rounded-full bg-purple-600/35 blur-[120px]" />
      <div className="pointer-events-none absolute right-[10%] top-[10%] w-52 h-52 rounded-full bg-cyan-500/20 blur-[100px]" />
      <div className="relative">
        <p className="inline-flex items-center gap-2 vt-glass px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest text-purple-200 mb-5"><Sparkles className="w-3.5 h-3.5" /> Tu turno</p>
        <h3 className="text-3xl md:text-4xl font-extrabold mb-3">¿Quieres este análisis para <span className="vt-gradient-text vt-gradient-text-glow">tu video</span>?</h3>
        <p className="text-brand-text2 max-w-2xl mx-auto mb-8">Pega la URL de cualquier video de YouTube o tu guion y recibe en menos de un minuto el mismo informe profesional que acabas de ver.</p>
        <ul className="flex flex-wrap items-center justify-center gap-2.5 mb-8">
          {points.map(([Icon, text]) => (
            <li key={text} className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3.5 py-1.5 text-xs sm:text-sm text-white">
              <Icon className="w-4 h-4 text-purple-300" /> {text}
            </li>
          ))}
        </ul>
        <a href="/" data-testid="share-footer-cta-button" className="vt-btn-primary vt-cta-glow px-8 py-4 rounded-2xl text-base">
          <Sparkles className="w-5 h-5" /> Analizar mi video gratis <ArrowRight className="w-5 h-5" />
        </a>
      </div>
    </section>
  );
}
